'use client';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { useShopifyOfferContext } from '../../../offer/shopifyContext';
import { renderNavigationLink } from '../functions';
import { StyledNavLinkGroup, NavLinkGroupHeading } from './styles';

export const NavLinkGroup = ({
  heading,
  links,
  closeMenu,
  menuBgColor,
  linkFontColor = 'text.lightest',
  headingFontColor = 'text.lightest',
  index,
}) => {
  const { formattedAmount } = useShopifyOfferContext();

  return (
    <StyledNavLinkGroup $index={Number(index)}>
      <NavLinkGroupHeading $fontColor={headingFontColor}>
        {interpolate(heading, { offer: formattedAmount })}
      </NavLinkGroupHeading>
      {links?.map((link, index) =>
        renderNavigationLink(link, index, {
          linkFontColor,
          closeMenu,
          menuBgColor,
          formattedAmount,
          type: 'mobile',
          variant: 'group',
        }),
      )}
    </StyledNavLinkGroup>
  );
};

NavLinkGroup.displayName = 'NavLinkGroup';

NavLinkGroup.propTypes = {
  heading: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string,
      text: PropTypes.string,
      component: PropTypes.string,
    }),
  ),
  closeMenu: PropTypes.func.isRequired,
  menuBgColor: PropTypes.string,
  linkFontColor: PropTypes.string,
  headingFontColor: PropTypes.string,
  index: PropTypes.number,
};
